import { action, createRequestTypes } from '../base';

export const customStatusActionTypes = {
  GET_CUSTOM_STATUS: createRequestTypes('GET_CUSTOM_STATUS'),
  CREATE_CUSTOM_STATUS: createRequestTypes('CREATE_CUSTOM_STATUS'),
  UPDATE_CUSTOM_STATUS: createRequestTypes('UPDATE_CUSTOM_STATUS'),
  DELETE_CUSTOM_STATUS: createRequestTypes('DELETE_CUSTOM_STATUS'),
  GET_ORG_STATUS: createRequestTypes('GET_ORG_STATUS'),
};

class CustomStatusActions {
  getCustomStatus = (payload, callback) => action(customStatusActionTypes.GET_CUSTOM_STATUS.REQUEST, {
    payload, callback,
  })

  getCustomStatusLoading = (getCustomStatusLoading, entityType) => action(customStatusActionTypes.GET_CUSTOM_STATUS.LOADING, {
    getCustomStatusLoading,
    entityType,
  })

  getCustomStatusSuccess = (getCustomStatusSuccess, entityType) => action(customStatusActionTypes.GET_CUSTOM_STATUS.SUCCESS, {
    getCustomStatusSuccess, entityType,
  })

  getOrgStatus = (payload, callback) => action(customStatusActionTypes.GET_ORG_STATUS.REQUEST, {
    payload, callback,
  })

  getOrgStatusLoading = (getOrgStatusLoading, entityType) => action(customStatusActionTypes.GET_ORG_STATUS.LOADING, {
    getOrgStatusLoading,
    entityType,
  })

  getOrgStatusSuccess = (getOrgStatusSuccess, entityType) => action(customStatusActionTypes.GET_ORG_STATUS.SUCCESS, {
    getOrgStatusSuccess, entityType,
  })

  createCustomStatus = (payload, callback) => action(customStatusActionTypes.CREATE_CUSTOM_STATUS.REQUEST, {
    payload,
    callback,
  })

  createCustomStatusLoading = (createCustomStatusLoading) => action(customStatusActionTypes.CREATE_CUSTOM_STATUS.LOADING, {
    createCustomStatusLoading,
  })

  updateCustomStatus = (payload, callback) => action(customStatusActionTypes.UPDATE_CUSTOM_STATUS.REQUEST, {
    payload,
    callback,
  })

  updateCustomStatusLoading = (updateCustomStatusLoading) => action(customStatusActionTypes.UPDATE_CUSTOM_STATUS.LOADING, {
    updateCustomStatusLoading,
  })

  deleteCustomStatus = (payload, callback) => action(customStatusActionTypes.DELETE_CUSTOM_STATUS.REQUEST, {
    payload, callback,
  })

  deleteCustomStatusLoading = (deleteCustomStatusLoading) => action(customStatusActionTypes.DELETE_CUSTOM_STATUS.LOADING, {
    deleteCustomStatusLoading,
  })
}

export default new CustomStatusActions();
